import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=0e4efb0c&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4efb0c')) {
      api.createRecord('0e4efb0c', component.options)
    } else {
      api.reload('0e4efb0c', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=0e4efb0c&", function () {
      api.rerender('0e4efb0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layouts/HeaderBar/MenuItem.vue"
export default component.exports